import { useTranslateMessage } from '@mc/internationalization/translationUtils';

export const useText = ({
  startRange = 0,
  endRange = '',
  totalCount = '',
} = {}) => {
  return {
    firstPageLabel: useTranslateMessage({
      id: 'surveys.ui_controls.basic_paginator.first_page',
      defaultMessage: 'First page',
    }),
    previousPageLabel: useTranslateMessage({
      id: 'surveys.ui_controls.basic_paginator.previous_page',
      defaultMessage: 'Previous page',
    }),
    nextPageLabel: useTranslateMessage({
      id: 'surveys.ui_controls.basic_paginator.next_page',
      defaultMessage: 'Next page',
    }),
    lastPageLabel: useTranslateMessage({
      id: 'surveys.ui_controls.basic_paginator.last_page',
      defaultMessage: 'Last page',
    }),
    paginationDetails: useTranslateMessage({
      id: 'surveys.ui_controls.basic_paginator.pagination_details',
      defaultMessage: 'Surveys {startRange} – {endRange} of {totalCount}',
      values: {
        startRange,
        endRange,
        totalCount,
      },
    }),
  };
};
